import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import { Skeleton } from '@material-ui/lab';

import { SourceStatus } from './applicant-source-status';

import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';

type InputProps = {
  status: SourceStatus | null;
};

export const ApplicantSourceStatusIcon = ({ status }: InputProps) => {
  const { NEEDS_REVIEW, PENDING, SUCCESS, NA, INACTIVE, NOT_PUBLISHED } = SourceStatus;

  // MaterialDesignIcon size sm is 20px by 20px
  let icon = <Skeleton variant="circle" width={20} height={20} />;
  let tooltip: string | null = null;

  switch (status) {
    case SUCCESS:
      icon = (
        <MaterialDesignIcon
          iconName={ICON_NAMES.CHECK_CIRCLE}
          size="sm"
          color="success"
          tooltip="Successfully posted"
        />
      );
      break;
    case NEEDS_REVIEW:
      icon = (
        <MaterialDesignIcon
          iconName={ICON_NAMES.ERROR}
          size="sm"
          color="error"
          tooltip="Problem with posting"
        />
      );
      break;
    case PENDING:
      icon = (
        <MaterialDesignIcon
          iconName={ICON_NAMES.SCHEDULE}
          size="sm"
          color="gray"
          tooltip="Posting in progress"
        />
      );
      break;
    case NA:
      icon = (
        <MaterialDesignIcon
          iconName={ICON_NAMES.DO_NOT_DISTURB_ON}
          size="sm"
          color="gray"
          tooltip="Status not available"
        />
      );
      break;
    case INACTIVE:
      icon = (
        <MaterialDesignIcon
          iconName={ICON_NAMES.PAUSE_CIRCLE}
          size="sm"
          color="gray"
          tooltip="Inactive job"
        />
      );
      break;
    case NOT_PUBLISHED:
      icon = (
        <MaterialDesignIcon
          iconName={ICON_NAMES.PAUSE_CIRCLE}
          size="sm"
          color="gray"
          tooltip="Not currently advertising"
        />
      );
      break;
    default:
      tooltip = 'Loading...';
      break;
  }

  return tooltip ? <Tooltip title={tooltip}>{icon}</Tooltip> : icon;
};
